import DOMPurify from "dompurify";
import { FC } from "react";

import __ from "web/Layout/Translations";

import { IDuplicateCardData } from "web/types/Subscription";

import defaultClasses from "./duplicateAlreadyOrdered.scss";

interface IDuplicatedAlreadyOrdered {
  duplicateCardData: IDuplicateCardData;
}

const DuplicateAlreadyOrdered: FC<IDuplicatedAlreadyOrdered> = ({
  duplicateCardData,
}) => {
  return (
    <>
      <div className={defaultClasses.duplicateElement}>
        <span className={defaultClasses.duplicateElement__ordered}>
          {__("Duplikat został zamówiony")}
        </span>
        {duplicateCardData.duplicateInfo && (
          <div
            className={`${defaultClasses.duplicateElement__info} cke_editable`}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(duplicateCardData.duplicateInfo),
            }}
          />
        )}
      </div>
    </>
  );
};

export default DuplicateAlreadyOrdered;
